module.exports = __webpack_public_path__ + "img/ruihong_01.a945d001.jpg";